// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__2uUcq"};